// CompanyRetirementPDF.js
import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import moment from "moment";
import logo from "../../logo-succession-now.png";
import Shape from "../../shape.png";
//import { display } from "html2canvas/dist/types/css/property-descriptors/display";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    flexWrap: "wrap",
    padding: 10,
    fontSize: 10,
  },
  // card: {
  //   width: "48%",
  //   margin: "1%",
  //   border: "1 solid #ccc",
  //   borderRadius: 8,
  //   padding: 10,
  //   backgroundColor: "#ffffff",
  //   boxshadow: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  // },
  cardHeader: {
    fontSize: 12,
    marginBottom: 6,
    fontWeight: "bold",
    color: "#111",
  },
  cardSub: {
    fontSize: 10,
    marginBottom: 8,
    color: "#444",
  },
  person: {
    paddingVertical: 4,
    borderBottom: "1 solid #eee",
  },
  name: {
    fontWeight: "bold",
    marginBottom: 2,
  },
  position: {
    fontSize: 9,
    color: "#666",
  },
  emptyMessage: {
    fontStyle: "italic",
    color: "#aaa",
    textAlign: "center",
    padding: 10,
  },
  gridContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: 10,
  },
  cardWrapper: {
    width: "100%",
    marginBottom: 20,
  },
  card: {
    borderRadius: 15,
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 3,
    overflow: "hidden",
    marginBottom: 5,
  },
  cardHeader: {
    backgroundColor: "#0f1c35",
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  cardTitle: {
    color: "#fff",
    fontSize: 14,
    fontWeight: "semibold",
  },
  cardSubtitle: {
    color: "#cfd8e3",
    fontSize: 10,
    marginTop: 2,
  },
  cardBody: {
    backgroundColor: "#fff",
    padding: 10,
  },
  personItem: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    borderColor: "#fddc9b",
    borderWidth: 1,
    borderRadius: 10,
    padding: 10,
    marginBottom: 10,
  },
  dot: {
    width: 10,
    height: 10,
    backgroundColor: "#f4c542",
    borderRadius: 5,
    marginRight: 10,
  },
  personName: {
    fontSize: 12,
    fontWeight: "bold",
  },
  personRole: {
    fontSize: 10,
    color: "#6c757d",
  },
  noRetirees: {
    textAlign: "center",
    padding: 10,
    color: "#888",
  },
});

const CompanyRetirementDataPDF = ({
  chartImageUrl,
  groups,
  user,
  companyLogo,
  employees,
  title,
  pageTitle = "Company Retirement Data Report",
  pageSubTitle = "Retiree",
  customLegend
}) => {
  const grouped = groups
    .sort((a, b) => a.ordering - b.ordering)
    .map((group) => {
      const people = employees?.filter((emp) => emp?.window === group?.name);
      return {
        ...group,
        people,
      };
    });    

  return (
    <Document>
      <Page
        size="A4"
        //orientation="landscape"
        style={{
          padding: 20,
          fontFamily: "RobotoRegular",
          lineHeight: 1.2,
          fontSize: 9,
          color: "#334155",
          backgroundColor: "#f1f5f9",
          position: "relative",
          zIndex: 0,
        }}
      >
        <View
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
          }}
          fixed
        >
          <View
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              right: 0,
              width: "100%",
              height: 160,
              zIndex: -1,
              opacity: 0.1,
            }}
          >
            <Image style={{ objectFit: "cover" }} src={Shape} />
          </View>
          <View
            style={{
              position: "absolute",
              width: "100%",
              left: 0,
              bottom: -10,
              right: 0,
              height: 160,
              zIndex: -1,
              opacity: 0.075,
            }}
          >
            <Image style={{ objectFit: "contain" }} src={logo} />
          </View>
        </View>
        <View style={{ position: "absolute", right: 30, top: 30 }}>
          <Image
            style={{ width: 120, height: 24, objectFit: "contain" }}
            src={logo}
          />
        </View>
        {/* <View
          style={{
            paddingBottom: 20,
            width: "100%",
            height: "90%",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <View
            style={{
              paddingBottom: 20,
              margin: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontSize: 16,
                alignItems: "center",
                position: "relative",
                width: "100%",
              }}
            >
              <Image
                style={{
                  width: 360,
                  height: 120,
                  objectFit: "contain",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                src={companyLogo}
              />
            </View>
            <View
              style={[
                {
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginTop: 15,
                },
              ]}
            >
              <Text
                style={[
                  {
                    fontFamily: "RobotoBold",
                    fontSize: 20,
                    textTransform: "capitalize",
                    textAlign: "center",
                  },
                ]}
              >
                Company Name: {user?.company_name}
              </Text>
            </View>
            <View
              style={[
                {
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginTop: 15,
                },
              ]}
            >
              <Text
                style={{
                  fontFamily: "RobotoBold",
                  fontSize: 12,
                  textTransform: "uppercase",
                  color: "#14b8a6",
                  letterSpacing: 3,
                  textAlign: "center",
                }}
              >
                {pageTitle}
              </Text>
            </View>
          </View>
          <View
            style={[
              {
                display: "flex",
                width: "100%",
                flexDirection: "row",
                marginTop: 5,
                textAlign: "center",
                justifyContent: "center",
              },
            ]}
          >
            <View
              style={[{ display: "flex", flexDirection: "row", marginTop: 5 }]}
            >
              <Text style={[{ fontFamily: "RobotoBold", fontSize: 10 }]}>
                Date:
              </Text>
              <Text
                style={{
                  fontFamily: "RobotoRegular",
                  fontSize: 10,
                  marginLeft: 2,
                }}
              >
                {moment(new Date()).format("MM/DD/YYYY")}
              </Text>
            </View>
          </View>
        </View> */}        
        <View
          style={{
            paddingBottom: 30,
            width: "100%",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          
          <View
            style={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              fontSize: 16,
              alignItems: "center",
              position: "relative",
              width: "100%",
            }}
          >
            <Image
              style={{
                width: 360,
                height: 120,
                objectFit: "contain",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              src={companyLogo}
            />
          </View>
          <View style={{ display: "flex", flexDirection: "row", marginTop: 15 }}>
            <Text
              style={{
                fontFamily: "RobotoBold",
                fontSize: 20,
                textTransform: "capitalize",
              }}
            >
              Company Name: {user?.company_name}
            </Text>
          </View>  
          <View
            style={[
              {
                display: "flex",
                flexDirection: "row",
                marginTop: 5,
                textAlign: "center",
                justifyContent: "center",
              },
            ]}
          >              
            <View
              style={[{ display: "flex", flexDirection: "row", marginTop: 5 }]}
            >
              <Text style={[{ fontFamily: "RobotoMedium", fontSize: 10 }]}>
                Date:
              </Text>
              <Text
                style={{
                  fontFamily: "RobotoRegular",
                  fontSize: 10,
                  marginLeft: 2,
                }}
              >
                {moment(new Date()).format("MM/DD/YYYY")}
              </Text>
            </View>
          </View>
        </View>
         <View
          style={{
            border: "1px solid #e2e8f0",
            borderRadius: 16,
            overflow: "hidden",
            backgroundColor: "#fff",
            padding: 20,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 500,
          }}
          wrap={false}
        >
          {chartImageUrl && (
            <Image 
              src={chartImageUrl} 
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                minHeight: 420, // Much larger image
              }}
              //style={styles.chartImage} 
            />
          )}

          <View
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'center',
              marginTop: 4, // mt-4 in Tailwind
              gap: 8, // approximate gap-y-2 and gap-x-6
            }}
          >
            {customLegend?.map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginRight: 12, // gap-x-6
                  marginBottom: 8, // gap-y-2
                }}
              >
                {/* Color box */}
                <View
                  style={{
                    width: 16, // w-4
                    height: 16, // h-4
                    borderRadius: 2, // rounded-sm
                    backgroundColor: item?.color,
                  }}
                />

                {/* Label and value */}
                <Text
                  style={{
                    fontSize: 14, // text-sm
                    fontWeight: '600', // font-semibold
                    color: '#374151', // text-slate-700
                    marginLeft: 4, // gap-2
                  }}
                >
                  {item?.label} ({item?.value})
                </Text>
              </View>
            ))}
          </View>
        </View>
      </Page>   
         
      <Page
        size="A4"
        //orientation="landscape"
        style={{
          padding: 20,
          fontFamily: "RobotoRegular",
          lineHeight: 1.2,
          fontSize: 9,
          color: "#334155",
          backgroundColor: "#f1f5f9",
          position: "relative",
          zIndex: 0,
        }}
      > 
       <Text style={[
          styles.title, 
          { 
            marginBottom: 24,
            textShadow: "0 2px 4px rgba(0,0,0,0.1)", // Inline shadow
            borderBottom: "3px solid #3b82f6", // Inline accent line
            paddingBottom: 12,
            display: "inline-block",
            width: "100%",
            fontSize: '18px',
            textTransform: 'capitalize',
            fontWeight: 'semibold',
          }
        ]}>
          Detailed Retirement Breakdown
        </Text>

        <View style={styles.gridContainer} wrap={true}>
          {grouped?.map((group, index) => (
            <View key={group._id} style={styles.cardWrapper} wrap={false}>
              <View style={styles.card}>
                <View style={styles.cardHeader} wrap={false}>
                  <Text style={styles.cardTitle}>{group?.name?.replace(/(Eliminates this candidate)/gi, "").replace(/[{()}]/g, "")}</Text>
                  <Text style={styles.cardSubtitle}>
                    {group.people.length > 0
                      ? `${group.people.length} ${pageSubTitle}${group.people.length > 1 ? "s" : ""}`
                      : `0 ${pageSubTitle}`}
                  </Text>
                </View>                
                <View style={styles.cardBody}>
                  {group.people?.length > 0 ? (
                    group.people.map((emp, idx) => (
                      <View wrap={false} key={idx} style={styles.personItem}>
                        <View style={styles.dot} />
                        <View>
                          <Text style={styles.personName}>{emp.name}</Text>
                          <Text style={styles.personRole}>{emp.position}</Text>
                        </View>
                      </View>
                    ))
                  ) : (
                    <Text style={styles.noRetirees}>
                      No retirees in this window
                    </Text>
                  )}
                </View>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default CompanyRetirementDataPDF;
